import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { StringOrPhoneNumber } from "src/app/models/common.model";
import { Address } from "src/app/services/address-book.service";
import { ScrBaseComponent } from "../../base.component";
import { FormGroupControls } from "./checkout.payment.component";
import { ConfigService } from "src/app/services";

export interface BillingInfoSource {
  billingFirstName?: string;
  billingLastName?: string;
  billingPhone?: StringOrPhoneNumber;
  billingPhoneExtension?: string;
  billingEmail?: string;
  billingAddress1?: string;
  billingAddress2?: string;
  billingCity?: string;
  billingState?: string;
  billingZip?: string;
  billingCountry?: string;
}

@Component({
  selector: 'app-billinginformation',
  templateUrl: './billinginformation.component.html'
})
export class BillingInformationComponent extends ScrBaseComponent implements OnInit {

  @Input() submitted = false;
  @Input() form!: FormGroup;

  @Input() set defaults(value: BillingInfoSource | undefined) {
    if (this.form.controls && value) {
      this.form.controls['billingFirstName'].setValue(value.billingFirstName);
      this.form.controls['billingLastName'].setValue(value.billingLastName);
      this.form.controls['billingPhone'].setValue(value.billingPhone);
      this.form.controls['billingPhoneExtension'].setValue(value.billingPhoneExtension);
      this.form.controls['billingEmail'].setValue(value.billingEmail);
      this.form.controls['billingAddress1'].setValue(value.billingAddress1);
      this.form.controls['billingAddress2'].setValue(value.billingAddress2);
      this.form.controls['billingCity'].setValue(value.billingCity);
      this.form.controls['billingState'].setValue(value.billingState);
      this.form.controls['billingZip'].setValue(value.billingZip);
      this.form.controls['billingCountry'].setValue(value.billingCountry);
    }
  }
  public publicEmailDomains: string[] = [];
  constructor(
    public configService: ConfigService) {
    super();
  }

  ngOnInit() {
    this.configService.getConfig().subscribe(cfg => {
      this.publicEmailDomains = cfg.publicEmailDomains;
    });
  }
  formGroup(): FormGroupControls {
    return {
      billingFirstName: new FormControl<string>(this.defaults?.billingFirstName ?? '', [Validators.required]),
      billingLastName: new FormControl<string>(this.defaults?.billingLastName ?? '', [Validators.required]),
      billingPhone: new FormControl<string>(this.defaults?.billingPhone?.toString() ?? '', [Validators.required]),
      billingPhoneExtension: new FormControl<string>(this.defaults?.billingPhoneExtension ?? '', []),
      billingEmail: new FormControl<string>(this.defaults?.billingEmail ?? '', [Validators.required]),
      billingAddress1: new FormControl<string>( this.defaults?.billingAddress1 ?? '', [Validators.required]),
      billingAddress2: new FormControl<string>(this.defaults?.billingAddress2 ?? '', []),
      billingCity: new FormControl<string>(this.defaults?.billingCity ?? '', [Validators.required]),
      billingState: new FormControl<string>(this.defaults?.billingState ?? '', []),
      billingZip: new FormControl<string>(this.defaults?.billingZip ?? '', []),
      billingCountry: new FormControl<string>(this.defaults?.billingCountry ?? '', [Validators.required]),
    };
  }
  loadAddress(address: Address) {
    this.form.controls['billingFirstName'].setValue(address.firstName);
    this.form.controls['billingLastName'].setValue(address.lastName);
    this.form.controls['billingPhone'].setValue(address.phone);
    this.form.controls['billingPhoneExtension'].setValue(address.phoneExtension);
    this.form.controls['billingEmail'].setValue(address.email);
    this.form.controls['billingCountry'].setValue(address.country);
    this.form.controls['billingAddress1'].setValue(address.address1);
    this.form.controls['billingAddress2'].setValue(address.address2);
    this.form.controls['billingCity'].setValue(address.city);
    // due to the wacky way country dropdown interacts with state and zip, changing the country
    // blanks out state and zip if different.  If we set them immediately, the country value
    // change kicks off a timed blanking of state and zip.   We need to delay populating them.
    setTimeout(() => {
      this.form.controls['billingState'].setValue(address.state);
      this.form.controls['billingZip'].setValue(address.zip);
    }, 200);
  }
}